import React, { useState } from "react";
import Input from "./Input";
import { useToasts } from "react-toast-notifications";
import Output from "./Output";
const Vertical = (props) => {
  const { addToast } = useToasts();
  let details = [];
  let firstinput = {
    direction: 180,
    radius: 10,
    depth: 10,
    dir: 180,
    amt: 50,
    startdepth: 0,
    enddepth: 40,
  };
  details = [firstinput];
  const [dimensions, setDimensions] = useState(details);
  const [traceCount, setTraceCount] = useState(details.length - 1);
  const [currentTrace, setCurrentTrace] = useState(details.length - 1);
  const [isOutput, setIsOutput] = useState(false);
  const [isDebug, setDebug] = useState(false);
  const [isEditInput, setIsEditInput] = useState(false);
  const updateDimension = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let newdim = [...dimensions];
    console.log(name, value);
    if (name === "direction" && (e.target.value < 0 || e.target.value > 359)) {
      addToast("Oops! Please choose the input value between 0 and 359", {
        appearance: "error",
      });
      newdim[currentTrace][name] = value;
      setDimensions(newdim);
      return false;
    }
    // let newdim = { ...dimensions };
    newdim[currentTrace][name] = value;
    setDimensions(newdim);
  };
  const showOutput = () => {
    setIsOutput(true);
    setDebug(false);
    setIsEditInput(false);
  };
  const showInput = () => {
    setIsOutput(false);
    setDebug(false);
    setIsEditInput(true);
  };
  const addTrace = () => {
    // Seed the new trace from the live first trace so the shared shaft
    // geometry (direction, radius, startdepth, enddepth) carries over —
    // `details` is rebuilt from the default literals on every render and
    // does NOT reflect what the user entered.
    let init = { ...dimensions[0] };

    let temp = [...dimensions];
    temp.push(init);
    setDimensions(temp);
    let newtracecount = traceCount + 1;
    setTraceCount(newtracecount);
    setCurrentTrace(newtracecount);
    setIsEditInput(false);
    setIsOutput(false);
  };
  const deleteTrace = (key) => {
    let temp = [...dimensions];
    if (key > -1) {
      temp.splice(key, 1);
    }
    setDimensions(temp);
    let newtracecount = traceCount - 1;
    setTraceCount(newtracecount);
    setCurrentTrace(newtracecount);
  };
  // Reset Values button: zero every input field and collapse to a single trace
  const resetValues = () => {
    const zeroed = {
      direction: 0,
      radius: 0,
      depth: 0,
      dir: 0,
      amt: 0,
      startdepth: 0,
      enddepth: 0,
    };
    setDimensions([zeroed]);
    setTraceCount(0);
    setCurrentTrace(0);
  };
  return !isOutput ? (
    <Input label="Create Trace" isEditInput={isEditInput} dimensions={dimensions} setcurrenttrace={setCurrentTrace} tracecount={traceCount} currenttrace={currentTrace} updatedimension={updateDimension} showoutput={showOutput} resetvalues={resetValues} showobjective={() => props.setstep("objective")} />
  ) : (
    <Output showinput={showInput} showdebug={isDebug} setshowdebug={setDebug} dimensions={dimensions} addtrace={addTrace} tracecount={traceCount} deletetrace={deleteTrace} currenttrace={currentTrace} />
  );
};

export default Vertical;
